import script from "./FooterAzvmsv.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterAzvmsv.vue?vue&type=script&setup=true&lang=js"

import "./FooterAzvmsv.vue?vue&type=style&index=0&id=163cd031&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163cd031"]])

export default __exports__